import { render } from "./Disertantes.vue?vue&type=template&id=2703aada"
import script from "./Disertantes.vue?vue&type=script&lang=js"
export * from "./Disertantes.vue?vue&type=script&lang=js"

import "./Disertantes.vue?vue&type=style&index=0&id=2703aada&lang=css"

import exportComponent from "D:\\Trabajo\\Raxar\\backoffice-base-vue3\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__